import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { getIn } from 'formik';
import { Row, Col } from '~layout';
import FormInputFeedback from './feedback/FormInputFeedback';
import FormSwitch from './FormSwitch';
import FormSwitchLabel from './switch/FormSwitchLabel';
import formPropTypes from '../prop-types/formPropTypes';

var FormSwitchInput = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FormSwitchInput, _React$Component);

  function FormSwitchInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          field = _this$props.field,
          onChange = _this$props.onChange;
      field.onChange(event);

      if (onChange) {
        onChange(event);
      }
    };

    return _this;
  }

  var _proto = FormSwitchInput.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        id = _this$props2.id,
        field = _this$props2.field,
        form = _this$props2.form,
        title = _this$props2.title,
        sizeValue = _this$props2.sizeValue,
        tagOnLabelId = _this$props2.tagOnLabelId,
        tagOffLabelId = _this$props2.tagOffLabelId,
        skin = _this$props2.skin,
        disabled = _this$props2.disabled;
    var error = getIn(form.errors, field.name);
    var touch = getIn(form.touched, field.name);
    var value = getIn(form.values, field.name) || false;
    var isSubmitted = form.submitCount > 0;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, title && /*#__PURE__*/React.createElement(Col, {
      xs: 15
    }, /*#__PURE__*/React.createElement(FormSwitchLabel, {
      htmlFor: id,
      skin: skin
    }, title)), /*#__PURE__*/React.createElement(Col, {
      xs: title ? 9 : 24
    }, /*#__PURE__*/React.createElement(FormSwitch, {
      id: id,
      name: field.name,
      onChange: this.handleChange,
      value: value,
      sizeValue: sizeValue,
      tagOn: tagOnLabelId,
      tagOff: tagOffLabelId,
      disabled: disabled
    }))), error && (touch || isSubmitted) && /*#__PURE__*/React.createElement(FormInputFeedback, {
      feedbackType: "error",
      id: id,
      message: error,
      skin: skin
    }));
  };

  return FormSwitchInput;
}(React.Component);

FormSwitchInput.defaultProps = {
  title: undefined,
  tagOnLabelId: 'switch.on.label',
  tagOffLabelId: 'switch.off.label',
  sizeValue: 'default',
  onChange: null,
  skin: 'dark',
  disabled: false
};
export default FormSwitchInput;